var map = {
	"./category_tags_controller.js": 316,
	"./coin_guides_readmore_controller.js": 317,
	"./coin_news_guides_controller.js": 318,
	"./coin_news_readmore_controller.js": 319,
	"./historical_controller.js": 320,
	"./intotheblock_controller.js": 321,
	"./ratings_widget_controller.js": 322,
	"./sentiment_vote_controller.js": 606,
	"./ticker_sponsored_ads_controller.js": 323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 315;